import { GeoLocation } from '../model/geoLocation';
import { GeoCoordinates, parseCoordinates } from './geo-coordinates';

const EARTH_RADIUS_KM = 6371;

export function distanceKm(from: GeoCoordinates, to: GeoCoordinates): number {
  const fromLat = toRadians(from.lat);
  const toLat = toRadians(to.lat);
  const deltaLat = toRadians(to.lat - from.lat);
  const deltaLng = toRadians(to.lng - from.lng);
  const haversine =
    Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
    Math.cos(fromLat) * Math.cos(toLat) * Math.sin(deltaLng / 2) * Math.sin(deltaLng / 2);
  return 2 * EARTH_RADIUS_KM * Math.atan2(Math.sqrt(haversine), Math.sqrt(1 - haversine));
}

/** Locations without coordinates go last. */
export function compareByDistanceFromUser(
  user: GeoCoordinates,
  first?: GeoLocation | null,
  second?: GeoLocation | null,
): number {
  return compareByDistanceKm(user, parseCoordinates(first), parseCoordinates(second));
}

export function compareByDistanceKm(
  user: GeoCoordinates,
  first: GeoCoordinates | null,
  second: GeoCoordinates | null,
): number {
  if (!first && !second) {
    return 0;
  }
  if (!first) {
    return 1;
  }
  if (!second) {
    return -1;
  }
  return distanceKm(user, first) - distanceKm(user, second);
}

export function formatDistanceKm(km: number): string {
  if (!Number.isFinite(km) || km < 0) {
    return '';
  }
  if (km < 1) {
    return `${Math.round(km * 1000)} m`;
  }
  if (km < 10) {
    return `${km.toFixed(1).replace('.', ',')} km`;
  }
  return `${Math.round(km)} km`;
}

export function distanceFromUserLabel(
  user: GeoCoordinates | null | undefined,
  point: GeoCoordinates | null | undefined,
): string {
  if (!user || !point) {
    return '';
  }
  const formatted = formatDistanceKm(distanceKm(user, point));
  return formatted ? `a ${formatted}` : '';
}

function toRadians(value: number): number {
  return (value * Math.PI) / 180;
}
